module.exports = __webpack_public_path__ + "img/25.8b5d1c3f.jpg";